<form class="w-[50vw] ml-[25vw] pt-[1vh]" [formGroup]="createPetForm">
  <div class="flex">
    <div class="w-[33.3334vw] pr-[0.5vw]">
      <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ `${'Pet.Owner'|translate}${'FieldRequiredMarker'|translate}` }}</div>
      <p-autocomplete id="owner" variant="filled" fluid="true" size="large"
                      formControlName="owner" [suggestions]="customersSuggestions"
                      (completeMethod)="filterCustomers($event)" [optionLabel]="getOptionLabelForOwner" [invalid]="isFormControlInvalid(createPetForm.controls.owner, submitButtonClicked)">
        <ng-template let-owner #selectedItem>
          <div>{{ owner.firstName }} {{ owner.lastName }}, {{ owner.street }} {{ owner.houseNumber }}
            , {{ owner.postalCode }} {{ owner.city }}, {{ owner.country }}
          </div>
        </ng-template>
        <ng-template let-owner #item>
          <div>{{ owner.firstName }} {{ owner.lastName }}, {{ owner.street }} {{ owner.houseNumber }}
            , {{ owner.postalCode }} {{ owner.city }}, {{ owner.country }}
          </div>
        </ng-template>
      </p-autocomplete>
    </div>
    <div class="w-[16.667vw] pl-[0.5vw]">
      <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start  mt-[1vh]"> {{ 'Pet.FirstTreatmentDate'|translate }}</div>
      <p-datepicker id="firstTreatmentDate" variant="filled" fluid="true" size="large" formControlName="firstTreatmentDate" showIcon
                    iconDisplay="input" [invalid]="isFormControlInvalid(createPetForm.controls.firstTreatmentDate, submitButtonClicked)"/>
    </div>
  </div>
  <div class="flex">
    <div class="w-[16.667vw] pr-[0.5vw]">
      <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ `${'Pet.Species'|translate}${'FieldRequiredMarker'|translate}` }}</div>
      <p-select id="species" [options]="species" variant="filled" fluid="true" size="large"
                formControlName="species" [invalid]="isFormControlInvalid(createPetForm.controls.species, submitButtonClicked)">
        <ng-template #selectedItem let-selectedSpecies>
          <div>{{ `Pet.Species.${selectedSpecies}`|translate }}</div>
        </ng-template>
        <ng-template #item let-item>
          <div>{{ `Pet.Species.${item}`|translate }}</div>
        </ng-template>
      </p-select>
    </div>
    <div class="w-[16.667vw] pr-[0.5vw] pl-[0.5vw]">
      <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ `${'Pet.Race'|translate}${'FieldRequiredMarker'|translate}`}}</div>
      <input id="race" type="text" variant="filled" fluid="true" pInputText pSize="large"
             formControlName="race" [invalid]="isFormControlInvalid(createPetForm.controls.race, submitButtonClicked)"/>
    </div>
    <div class="w-[16.667vw] pl-[0.5vw]">
      <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ 'Pet.Color'|translate }}</div>
      <input id="color" type="text" variant="filled" fluid="true" pInputText pSize="large"
             formControlName="color" [invalid]="isFormControlInvalid(createPetForm.controls.color, submitButtonClicked)"/>
    </div>
  </div>
  <div class="flex">
    <div class="w-[16.667vw] pr-[0.5vw]">
      <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ `${'Pet.Nickname'|translate}${'FieldRequiredMarker'|translate}`}}</div>
      <input id="name" type="text" variant="filled" fluid="true" pInputText pSize="large"
             formControlName="nickname" [invalid]="isFormControlInvalid(createPetForm.controls.nickname, submitButtonClicked)"/>
    </div>
    <div class="w-[16.667vw] pr-[0.5vw] pl-[0.5vw]">
      <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start  mt-[1vh]"> {{ 'Pet.DateOfBirth'|translate }}</div>
      <p-datepicker id="dateOfBirth" variant="filled" fluid="true" size="large" formControlName="dateOfBirth" showIcon
                    iconDisplay="input" [invalid]="isFormControlInvalid(createPetForm.controls.dateOfBirth, submitButtonClicked)"/>
    </div>
    <div class="w-[16.667vw] pl-[0.5vw]">
      <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ `${'Pet.Gender'|translate}${'FieldRequiredMarker'|translate}`}}</div>
      <p-select id="gender" [options]="genders" variant="filled" fluid="true" size="large"
                formControlName="gender" [invalid]="isFormControlInvalid(createPetForm.controls.gender, submitButtonClicked)">
        <ng-template #selectedItem let-selectedGender>
          <div>{{ ('Pet.Gender.' + selectedGender)|translate }}</div>
        </ng-template>
        <ng-template let-gender #item>
          <div>{{ ('Pet.Gender.' + gender)|translate }}</div>
        </ng-template>
      </p-select>
    </div>
  </div>
  <div class="flex">
    <div class="w-[16.667vw] pr-[0.5vw]">
      <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{`${'Pet.ChipNumber'|translate}`}}</div>
      <p-inputmask mask="999 9 999 99999999" placeholder="000 0 000 00000000" id="chipNumber" type="text" autoClear="false"
                   variant="filled"
                   fluid="true" size="large"
                   formControlName="chipNumber" [invalid]="isFormControlInvalid(createPetForm.controls.chipNumber, submitButtonClicked)"/>
    </div>
    <div class="w-[16.667vw] pl-[0.5vw] pr-[0.5vw]">
      <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start  mt-[1vh]"> {{ 'Pet.Behavior'|translate }}</div>
      <p-selectbutton id="behavior" [options]="behaviors" variant="filled" fluid="true" size="large" allowEmpty="false"
                      formControlName="behavior" [invalid]="isFormControlInvalid(createPetForm.controls.behavior, submitButtonClicked)">
        <ng-template #item let-item>
          <div [class]="getClassForBehavior(item)"></div>
        </ng-template>
      </p-selectbutton>
    </div>
    <div class="w-[16.667vw] pl-[0.5vw]">
      <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start  mt-[1vh]"> {{ 'Pet.HasBeenNeutered'|translate }}</div>
      <p-selectbutton id="neuteringStatus" [options]="neuteredStatusForms" variant="filled" fluid="true" size="large" allowEmpty="false"
                      formControlName="neuteringStatus" optionValue="value" [invalid]="isFormControlInvalid(createPetForm.controls.neuteringStatus, submitButtonClicked)">
        <ng-template #item let-item>
          <div>{{ item.label }}</div>
        </ng-template>
      </p-selectbutton>
    </div>
  </div>
  <div class="flex">
    <div class="w-[16.667vw] pr-[0.5vw]">
      <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ 'Pet.IsInsured'|translate }}</div>
      <p-selectbutton id="isInsured" [options]="boolOptions" variant="filled" fluid="true" size="large" allowEmpty="false"
                      formControlName="isInsured" [invalid]="isFormControlInvalid(createPetForm.controls.isInsured, submitButtonClicked)">
        <ng-template #item let-item>
          <div>{{ item.label }}</div>
        </ng-template>
      </p-selectbutton>
    </div>
    @if (createPetForm.value.isInsured) {
      <div class="w-[16.667vw] pr-[0.5vw] pl-[0.5vw]">
        <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ `${'Pet.InsuranceProvider'|translate}${'FieldRequiredMarker'|translate}` }}</div>
        <input id="insuranceProvider" type="text" variant="filled" fluid="true" pInputText pSize="large"
               formControlName="insuranceProvider" [invalid]="isFormControlInvalid(createPetForm.controls.insuranceProvider, submitButtonClicked)"/>
      </div>
      <div class="w-[16.667vw] pl-[0.5vw]">
        <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ `${'Pet.InsuranceNumber'|translate}${'FieldRequiredMarker'|translate}`}}</div>
        <input id="insuranceNumber" type="text" variant="filled" fluid="true" pInputText pSize="large"
               formControlName="insuranceNumber" [invalid]="isFormControlInvalid(createPetForm.controls.insuranceNumber, submitButtonClicked)"/>
      </div>
    }
  </div>
  <div class="flex">
    <div class="w-[16.667vw] pr-[0.5vw]">
      <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ 'Pet.HasHomeVet'|translate }}</div>
      <p-selectbutton id="hasHomeVet" [options]="boolOptions" variant="filled" fluid="true" size="large" allowEmpty="false"
                      formControlName="hasHomeVet" [invalid]="isFormControlInvalid(createPetForm.controls.hasHomeVet, submitButtonClicked)">
        <ng-template #item let-item>
          <div>{{ item.label }}</div>
        </ng-template>
      </p-selectbutton>
    </div>
    @if (createPetForm.value.hasHomeVet) {
      <div class="w-[16.667vw] pr-[0.5vw] pl-[0.5vw]">
        <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ `${'Pet.HomeVetName'|translate}${'FieldRequiredMarker'|translate}`}}</div>
        <input id="homeVetName" type="text" variant="filled" fluid="true" pInputText pSize="large"
               formControlName="homeVetName" [invalid]="isFormControlInvalid(createPetForm.controls.homeVetName, submitButtonClicked)"/>
      </div>
      <div class="w-[16.667vw] pl-[0.5vw]">
        <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ `${'Pet.HomeVetPhoneNumber'|translate}${'FieldRequiredMarker'|translate}` }}</div>
        <input id="homeVetPhoneNumber" type="text" variant="filled" fluid="true" pInputText pSize="large"
               formControlName="homeVetPhoneNumber" [invalid]="isFormControlInvalid(createPetForm.controls.homeVetPhoneNumber, submitButtonClicked)"/>
      </div>
    }
  </div>
  <div class="flex">
    <div class="w-[16.667vw] pr-[0.5vw]">
      <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ 'Pet.HasBreederGivenName'|translate }}</div>
      <p-selectbutton id="hasBreeder" [options]="boolOptions" variant="filled" fluid="true" size="large" allowEmpty="false"
                      formControlName="hasBreederGivenName" [invalid]="isFormControlInvalid(createPetForm.controls.hasBreederGivenName, submitButtonClicked)">
        <ng-template #item let-item>
          <div>{{ item.label }}</div>
        </ng-template>
      </p-selectbutton>
    </div>
    @if (createPetForm.value.hasBreederGivenName) {
      <div class="w-[16.667vw] pr-[0.5vw] pl-[0.5vw]">
        <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ `${'Pet.BreederGivenName'|translate}${'FieldRequiredMarker'|translate}`}}</div>
        <input id="breederGivenName" type="text" variant="filled" fluid="true" pInputText pSize="large"
               formControlName="breederGivenName" [invalid]="isFormControlInvalid(createPetForm.controls.breederGivenName, submitButtonClicked)"/>
      </div>
    }
  </div>
  <div class="flex">
  </div>
  <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ 'Pet.BehaviorNotes'|translate }}</div>
  <p-editor formControlName="behaviorNotes" [style]="{ height: '10vh' }" [invalid]="isFormControlInvalid(createPetForm.controls.behaviorNotes, submitButtonClicked)">
    <ng-template #header>
                <span class="ql-formats">
                  <button type="button" class="ql-bold" aria-label="Bold"></button>
                  <button type="button" class="ql-italic" aria-label="Italic"></button>
                  <button type="button" class="ql-underline" aria-label="Underline"></button>
                  <button type="button" class="ql-strike" aria-label="Strike"></button>
                  <span class="ql-formats">
                    <select class="ql-color" aria-label="Color">
                      <option selected></option>
                      <option value="red"></option>
                      <option value="blue"></option>
                      <option value="yellow"></option>
                      <option value="white"></option>
                    </select>
                  </span>
                  <span class="ql-formats">
                    <select class="ql-size" aria-label="Size">
                      <option selected></option>
                      <option value="small"></option>
                      <option value="large"></option>
                      <option value="huge"></option>
                    </select>
                  </span>
                </span>
    </ng-template>
  </p-editor>
  <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ 'Pet.Anamnesis'|translate }}</div>
  <p-editor formControlName="anamnesis" [style]="{ height: '10vh' }" [invalid]="isFormControlInvalid(createPetForm.controls.anamnesis, submitButtonClicked)">
    <ng-template #header>
                <span class="ql-formats">
                  <button type="button" class="ql-bold" aria-label="Bold"></button>
                  <button type="button" class="ql-italic" aria-label="Italic"></button>
                  <button type="button" class="ql-underline" aria-label="Underline"></button>
                  <button type="button" class="ql-strike" aria-label="Strike"></button>
                  <span class="ql-formats">
                    <select class="ql-color" aria-label="Color">
                      <option selected></option>
                      <option value="red"></option>
                      <option value="blue"></option>
                      <option value="yellow"></option>
                      <option value="white"></option>
                    </select>
                  </span>
                  <span class="ql-formats">
                    <select class="ql-size" aria-label="Size">
                      <option selected></option>
                      <option value="small"></option>
                      <option value="large"></option>
                      <option value="huge"></option>
                    </select>
                  </span>
                </span>
    </ng-template>
  </p-editor>

  <div class="flex justify-around mt-[3vh]">
    <p-button type="submit" size="large"
              label="{{'CreateCustomers.Save'|translate}}" (onClick)="onSubmit(false)"/>
    <p-button type="submit" size="large"
              label="{{'CreateCustomers.SaveAndAddTreatment'|translate}}" (onClick)="onSubmit(true)"/>
  </div>
</form>
